export interface UserEvent {
  eventType: string;
  createdAt?: Date;
}

export const USER_EVENT_TYPES = [
  'OCCURRENCE_CREATE',
  'OCCURRENCE_UPDATE',
  'OCCURRENCE_IMPORT',
  'OCCURRENCE_BATCH_UPDATE',
  'OCCURRENCE_STEP_CHANGE',
  'OCCURRENCE_FINALIZE',
  'OCCURRENCE_COMMENT_ADD',
  'OCCURRENCE_COMMENT_UPDATE',
  'OCCURRENCE_COMMENT_REMOVE',
  'SERVICE_APPOINTMENT_CREATE',
  'SERVICE_APPOINTMENT_RESCHEDULE',
  'SERVICE_APPOINTMENT_CANCEL',
  'ASSET_MANUAL_METRICS_UPDATE',
  'MAINTENANCE_GROUP_UPDATE',
  'OCCURRENCE_REVIEW',
  'DISPATCH_CREATE',
  'DISPATCH_UPDATE',
  'DISPATCH_DELETE',
  'DISPATCH_AVAILABLE',
  'DISPATCH_ASSIGN_DRIVER',
  'SERVICE_BAY_CREATE',
  'SERVICE_BAY_UPDATE',
  'SERVICE_BAY_DELETE',
  'SERVICE_BAY_SCHEDULE_CREATE',
  'SERVICE_BAY_SCHEDULE_CANCEL',
];

export const getUserEventMessageId = (eventType: string): string | undefined =>
  USER_EVENT_TYPES.includes(eventType) ? `intl-msg:backoffice.activity.event.${eventType}` : undefined;
